import {takeLatest} from 'redux-saga/effects'
import { GET_MENU_REQUEST,FETCH_SEARCH_OPTIONS_REQUEST } from './constants'
import { fetchMenu,fetchSearchOptions } from './fetchCommonData'
function* CommonSaga() {
    yield takeLatest(GET_MENU_REQUEST,fetchMenu);
    yield takeLatest(FETCH_SEARCH_OPTIONS_REQUEST,fetchSearchOptions)
}

export default CommonSaga;